<template lang="pug">
filter-detail-container(
  :title="$t('filter_segment')"
  @back="back"
  @save="save"
)
  template(v-slot:body)
    .px-6.pt-6.pb-2.text-md {{ $t('choose_segment_that_you_want_filter') }}:
    .text-center.mt-8(v-if="isLoading")
      v-progress-circular(width="2" size="30" color="primary" indeterminate)
    div(v-else)
      div(v-for="segment in segments" :key="segment.value")
        .d-flex.text-sm.pa-6
          yc-checkbox(v-model="selected" :value="segment.value")
          .ml-4.font-medium {{ segment.label }}
        v-divider.basic300
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterDetailContainer from './FilterDetailContainer.vue'

export default {
  props: ['filter'],
  components: { FilterDetailContainer },
  data: () => ({
    isLoading: true,
    selected: [],
    segments: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  created() {
    this.fetchSegments()
    if (this.filter.segments) {
      this.selected = this.filter.segments
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSegments() {
      this.isLoading = true
      this.$axios.get(`/connect/${this.company.slug}/groups?page_size=-1&exclude=customer`)
      .then(resp => {
        this.segments = resp.data.results.map(item => {
          return {
            label: item.title,
            value: `${item.id}`
          }
        })
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    save() {
      const titles = []
      this.selected.map(item => {
        const obj = this.segments.find(x => x.value === item)
        titles.push(obj.label)
      })
      const filter = {
        segments: this.selected,
        segment_titles: titles
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>